import { onMounted, reactive, ref } from 'vue'
import useGet from './api/useGet'
import type { CreateableObjective, Objective } from '@/core/composables/use-objectives'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '@/core/events/event-key'
import usePost from '@/core/composables/api/usePost'
import { ApiRequestStatus } from '@/core/models/api/api-request-status'
import { useUserStore } from '@/stores/user.store'

export const useMyObjectives = () => {
  const objectiveUpdatedBus = useEventBus(EventKey.objectiveUpdated)
  const { user } = useUserStore()

  const { data, load, status, reload } = useGet<{ objectives: ReadonlyArray<Objective> }>(
    'objectives/current',
  )
  const { mutate: create, status: createStatus } = usePost<
    CreateableObjective,
    CreateableObjective
  >(`objectives`)

  const showForm = ref(false)
  const creatableObjective = reactive<Partial<CreateableObjective>>({
    isImpulse: false,
  })

  const resetCreatableObjective = () => {
    creatableObjective.title = undefined
    creatableObjective.description = undefined
    creatableObjective.feedbackTopicId = undefined
    creatableObjective.isImpulse = false
  }

  onMounted(() => load())

  objectiveUpdatedBus.on(() => reload())

  const createObjective = () => {
    showForm.value = true
  }

  const cancelCreateObjective = () => {
    showForm.value = false
    resetCreatableObjective()
  }

  const saveObjective = async () => {
    if (!creatableObjective.title) {
      return
    }

    await create({
      title: creatableObjective.title,
      description: creatableObjective.description,
      feedbackTopicId: creatableObjective.feedbackTopicId,
      ownerId: user.id,
      isImpulse: false,
    })

    if (createStatus.value == ApiRequestStatus.Success) {
      cancelCreateObjective()
    }
    objectiveUpdatedBus.emit()
  }

  return {
    data,
    status,
    showForm,
    creatableObjective,
    createObjective,
    cancelCreateObjective,
    saveObjective,
  }
}
